import React, { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // ✅ Importamos useLocation
import "./Exportdeck.css";
import { API_URL } from "../../config/constants";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();


const ExportDeck = () => {
    useEffect(() => {
    fetch(`${API_URL}/endpoint`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Datos:", data);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      });
  }, []);
    const [deckCode, setDeckCode] = useState("");
    const [isExporting, setIsExporting] = useState(false);
    // ✅ Obtener edición desde la URL
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const edition = queryParams.get("edition") || "";

    // Obtener el mazo desde Redux
    const mainDeck = useSelector(state => state.deck.main);

    // Construir el objeto del mazo en el formato esperado
    const deckData = {
        name: "Mazo desde Redux",
        format_type: "Standard",
        edition: edition, // ✅ Incluimos la edición si el backend lo requiere
        cards: mainDeck.reduce((acc, card) => {
            acc[card.Id] = card.quantity;
            return acc;
        }, {})
    };

    const exportDeck = async () => {
    setIsExporting(true); // 🔹 Activar el spinner antes de empezar

    try {
        const response = await fetch(`${API_URL}/export`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(deckData)
        });

        const data = await response.json();
        setDeckCode(data.deck_code || "Error al exportar");
    } catch (error) {
        console.error("Error al exportar:", error);
    } finally {
        setIsExporting(false); // 🔹 Siempre desactivar el spinner al terminar (éxito o error)
    }
};


    const copyToClipboard = () => {
    navigator.clipboard.writeText(deckCode);
    toast.success("¡Código copiado!", {
        position: "bottom-center",
        autoClose: 2000,
    });
    };

    return (
        <div className="export">
            <button className="export-button-nc" onClick={exportDeck} disabled={isExporting}>
        {isExporting ? (
            <i className="fa-solid fa-spinner fa-spin"></i>
        ) : (
            "Exportar"
        )}
        </button>
            <h2>Código del Mazo</h2>
            <div className="export-container">
                <textarea
                    className="export-textarea"
                    value={deckCode}
                    placeholder="Aquí aparecerá el código..."
                    readOnly
                />
                <button className="export-button" onClick={copyToClipboard}>
                    <i className="fa-solid fa-copy"></i> {/* ✅ className corregido */}
                </button>
            </div>
        </div>
    );
};

export default ExportDeck;
